import { render, staticRenderFns } from "./AddAssess.vue?vue&type=template&id=66f62f9f&scoped=true"
import script from "./AddAssess.vue?vue&type=script&lang=js"
export * from "./AddAssess.vue?vue&type=script&lang=js"
import style0 from "./AddAssess.vue?vue&type=style&index=0&id=66f62f9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f62f9f",
  null
  
)

export default component.exports